import { jsx } from 'react/jsx-runtime';
import { CloseIcon } from '@flex-design-system/legacy-flex-icons';
import { composeEventHandlers } from '@radix-ui/primitive';
import { forwardRef } from 'react';
import { IconButton } from '../../../../button/icon-button/IconButton.mjs';
import { useLinearLocale } from '../../../../locale/LocaleContext.mjs';
import { localeValues } from '../../../shared/locale-values.mjs';
import { useSingleSelectContext } from '../../contexts/context.mjs';

const SingleSelectSearchFieldClearIconButton = forwardRef(({ onPointerDown, ...props }, forwardedRef) => {
  const { locale } = useLinearLocale();
  const { searchKeyword, onSearchKeywordChange } = useSingleSelectContext(
    "SearchFieldClearIconButton"
  );
  const handlePointerDown = composeEventHandlers(onPointerDown, (event) => {
    if (!event.isDefaultPrevented()) {
      onSearchKeywordChange("");
    }
  });
  if (searchKeyword === void 0 || searchKeyword.trim().length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    IconButton,
    {
      "aria-label": localeValues[locale].clear,
      variant: "plain",
      size: "small",
      color: "blackAlpha024",
      icon: /* @__PURE__ */ jsx(CloseIcon, { "aria-hidden": true, type: "fill" }),
      onPointerDown: handlePointerDown,
      ref: forwardedRef,
      ...props
    }
  );
});

export { SingleSelectSearchFieldClearIconButton as SelectSearchFieldClearIconButton };
//# sourceMappingURL=SearchFieldClearIconButton.mjs.map
